// import React, { useEffect, useState } from "react";
// import axios from "axios";
// // import Constant from "../../utils/constant"; // Assuming you might use this later
// import { useNavigate } from "react-router-dom";

import {
  DollarSign,
  Users,
  Clock,
  FileText,
  Download,
  Plus,
  Edit,
  Eye,
  Calendar,
  TrendingUp,
  AlertCircle,
} from "lucide-react";
// // ✅ 1. DEFINE THE MODAL AS A SEPARATE COMPONENT
// // It receives `details` and `onClose` as props.
// // Helper function to convert number to words (Simplified for Indian numbering)
// const toWords = (num) => {
//   const a = [
//     "",
//     "one ",
//     "two ",
//     "three ",
//     "four ",
//     "five ",
//     "six ",
//     "seven ",
//     "eight ",
//     "nine ",
//     "ten ",
//     "eleven ",
//     "twelve ",
//     "thirteen ",
//     "fourteen ",
//     "fifteen ",
//     "sixteen ",
//     "seventeen ",
//     "eighteen ",
//     "nineteen ",
//   ];
//   const b = [
//     "",
//     "",
//     "twenty",
//     "thirty",
//     "forty",
//     "fifty",
//     "sixty",
//     "seventy",
//     "eighty",
//     "ninety",
//   ];

//   const number = parseFloat(num).toFixed(2).split(".");
//   const main = number[0];
//   const decimal = number[1];

//   if (main.length > 7) {
//     return "Number too large";
//   }

//   const nToWords = (n) => {
//     let str = "";
//     if (n > 19) {
//       str += b[Math.floor(n / 10)] + " " + a[n % 10];
//     } else {
//       str += a[n];
//     }
//     return str;
//   };

//   let str = "";
//   str +=
//     nToWords(Math.floor(main / 100000) % 100).length > 0
//       ? nToWords(Math.floor(main / 100000) % 100) + "lakh "
//       : "";
//   str +=
//     nToWords(Math.floor(main / 1000) % 100).length > 0
//       ? nToWords(Math.floor(main / 1000) % 100) + "thousand "
//       : "";
//   str +=
//     nToWords(Math.floor(main / 100) % 10).length > 0
//       ? nToWords(Math.floor(main / 100) % 10) + "hundred "
//       : "";
//   if (main > 100 && main % 100 > 0) {
//     str += "and ";
//   }
//   str += nToWords(main % 100);

//   let decimalPart = "";
//   if (decimal && parseInt(decimal) > 0) {
//     decimalPart = ` and ${nToWords(parseInt(decimal))} paise`;
//   }

//   return str.trim() === ""
//     ? "Zero"
//     : str.trim().replace(/\s+/g, " ") + decimalPart;
// };

// // ✅ REPLACED MODAL COMPONENT
// const PayslipModal = ({ details, employee, onClose }) => {
//   if (!details || !employee) {
//     return null;
//   }

//   // Format the month (e.g., "June, 2025")
//   const payslipMonth = new Date(details.month + "-02").toLocaleString(
//     "default",
//     { month: "long", year: "numeric" }
//   );
//   const doj = new Date(employee.joining_date).toLocaleDateString("en-GB");

//   const earnings = {
//     BASIC: parseFloat(details.base_salary) || 0,
//     "H.R.A.": parseFloat(details.hra) || 0,
//     "CONVEY.": parseFloat(details.conveyance) || 0,
//     "SPL.ALL": parseFloat(details.special_allowance) || 0,
//     MEDICAL: 0,
//     "ATT. ALL": 0,
//     "PERF.BON": 0,
//   };

//   const deductions = {
//     "E.P.F. (Employee's Share)": parseFloat(details.pf) || 0,
//     "E.S.I.C. (Employee's Share)": parseFloat(details.esi) || 0,
//     ADVANCE: 0,
//     TDS: 0,
//     LOAN: 0,
//     "P.TAX": 0,
//   };

//   const totalEarnings = Object.values(earnings).reduce(
//     (acc, val) => acc + val,
//     0
//   );
//   const totalDeductions = Object.values(deductions).reduce(
//     (acc, val) => acc + val,
//     0
//   );

//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: "rgba(0, 0, 0, 0.7)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 1050,
//       }}
//     >
//       <div
//         style={{
//           backgroundColor: "white",
//           padding: "25px",
//           fontFamily: "Arial, sans-serif",
//           width: "800px",
//           border: "1px solid black",
//         }}
//       >
//         <div style={{ textAlign: "center", marginBottom: "20px" }}>
//           <h4 style={{ margin: "0", fontWeight: "bold" }}>
//             M/S POLICICUE INSURANCE BROKERS PRIVATE LIMITED
//           </h4>
//           <p style={{ margin: "0" }}>
//             A-42/6, Sector-62, Noida, Gautam Buddha Nagar, Uttar Pradesh-201301
//           </p>
//           <h5 style={{ margin: "10px 0 0 0", textDecoration: "underline" }}>
//             Salary Slip for the month of {payslipMonth}
//           </h5>
//         </div>

//         {/* Employee Details */}
//         <table
//           style={{
//             width: "100%",
//             borderCollapse: "collapse",
//             border: "1px solid black",
//             fontSize: "14px",
//           }}
//         >
//           <tbody>
//             <tr>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Employee Code
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.employee_id}
//               </td>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 P.F. Number
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.pf_number || "N/A"}
//               </td>
//             </tr>
//             <tr>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Employee Name
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {details.employee_name.toUpperCase()}
//               </td>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 PAN No.
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.pan_number || "N/A"}
//               </td>
//             </tr>
//             <tr>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 F/H Name
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.father_name || "N/A"}
//               </td>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Bank A/c No.
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.bank_account_number || "N/A"}
//               </td>
//             </tr>
//             <tr>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Designation
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.joining_position || "N/A"}
//               </td>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 ESI Number
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.esi_number || "N/A"}
//               </td>
//             </tr>
//             <tr>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Department
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {employee.department}
//               </td>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 D.O.J.
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {doj}
//               </td>
//             </tr>
//             <tr>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Paid Days
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {details.work_days.toFixed(2)}
//               </td>
//               <td
//                 style={{
//                   border: "1px solid black",
//                   padding: "4px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 Leave
//               </td>
//               <td style={{ border: "1px solid black", padding: "4px" }}>
//                 {details.leave_days.toFixed(2)}
//               </td>
//             </tr>
//           </tbody>
//         </table>

//         {/* Earnings and Deductions */}
//         <div
//           style={{
//             display: "flex",
//             width: "100%",
//             border: "1px solid black",
//             borderTop: "none",
//           }}
//         >
//           <div style={{ width: "60%", borderRight: "1px solid black" }}>
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: "14px",
//               }}
//             >
//               <thead>
//                 <tr style={{ backgroundColor: "#f2f2f2" }}>
//                   <th
//                     style={{
//                       border: "1px solid black",
//                       padding: "4px",
//                       borderTop: "none",
//                       borderLeft: "none",
//                     }}
//                   >
//                     Earnings
//                   </th>
//                   <th
//                     style={{
//                       border: "1px solid black",
//                       padding: "4px",
//                       borderTop: "none",
//                     }}
//                   >
//                     Rate
//                   </th>
//                   <th
//                     style={{
//                       border: "1px solid black",
//                       padding: "4px",
//                       borderTop: "none",
//                       borderRight: "none",
//                     }}
//                   >
//                     Earnings
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {Object.entries(earnings).map(([key, value]) => (
//                   <tr key={key}>
//                     <td
//                       style={{
//                         border: "1px solid black",
//                         padding: "4px",
//                         borderBottom: "none",
//                         borderLeft: "none",
//                       }}
//                     >
//                       {key}
//                     </td>
//                     <td
//                       style={{
//                         border: "1px solid black",
//                         padding: "4px",
//                         borderBottom: "none",
//                         textAlign: "right",
//                       }}
//                     >
//                       {value.toFixed(2)}
//                     </td>
//                     <td
//                       style={{
//                         border: "1px solid black",
//                         padding: "4px",
//                         borderBottom: "none",
//                         borderRight: "none",
//                         textAlign: "right",
//                       }}
//                     >
//                       {value.toFixed(2)}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div style={{ width: "40%" }}>
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: "14px",
//               }}
//             >
//               <thead>
//                 <tr style={{ backgroundColor: "#f2f2f2" }}>
//                   <th
//                     style={{
//                       border: "1px solid black",
//                       padding: "4px",
//                       borderTop: "none",
//                       borderLeft: "none",
//                     }}
//                   >
//                     Deductions
//                   </th>
//                   <th
//                     style={{
//                       border: "1px solid black",
//                       padding: "4px",
//                       borderTop: "none",
//                       borderRight: "none",
//                     }}
//                   >
//                     Amount
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {Object.entries(deductions).map(([key, value]) => (
//                   <tr key={key}>
//                     <td
//                       style={{
//                         border: "1px solid black",
//                         padding: "4px",
//                         borderBottom: "none",
//                         borderLeft: "none",
//                       }}
//                     >
//                       {key}
//                     </td>
//                     <td
//                       style={{
//                         border: "1px solid black",
//                         padding: "4px",
//                         borderBottom: "none",
//                         borderRight: "none",
//                         textAlign: "right",
//                       }}
//                     >
//                       {value.toFixed(2)}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Totals */}
//         <div
//           style={{
//             display: "flex",
//             width: "100%",
//             border: "1px solid black",
//             borderTop: "none",
//             fontSize: "14px",
//             fontWeight: "bold",
//           }}
//         >
//           <div
//             style={{
//               width: "60%",
//               display: "flex",
//               borderRight: "1px solid black",
//             }}
//           >
//             <div
//               style={{
//                 width: "33.33%",
//                 padding: "4px",
//                 borderRight: "1px solid black",
//               }}
//             >
//               Total
//             </div>
//             <div
//               style={{
//                 width: "33.33%",
//                 padding: "4px",
//                 textAlign: "right",
//                 borderRight: "1px solid black",
//               }}
//             >
//               {totalEarnings.toFixed(2)}
//             </div>
//             <div
//               style={{ width: "33.33%", padding: "4px", textAlign: "right" }}
//             >
//               {totalEarnings.toFixed(2)}
//             </div>
//           </div>
//           <div style={{ width: "40%", display: "flex" }}>
//             <div
//               style={{
//                 width: "50%",
//                 padding: "4px",
//                 borderRight: "1px solid black",
//               }}
//             >
//               Total
//             </div>
//             <div style={{ width: "50%", padding: "4px", textAlign: "right" }}>
//               {totalDeductions.toFixed(2)}
//             </div>
//           </div>
//         </div>

//         {/* Net Payable */}
//         <div
//           style={{
//             display: "flex",
//             width: "100%",
//             border: "1px solid black",
//             borderTop: "none",
//             fontSize: "14px",
//             fontWeight: "bold",
//           }}
//         >
//           <div style={{ width: "60%", padding: "4px" }}>
//             Net Payable for the Month {payslipMonth}
//           </div>
//           <div style={{ width: "40%", padding: "4px", textAlign: "right" }}>
//             {details.net_pay}
//           </div>
//         </div>

//         {/* In Words */}
//         <div
//           style={{
//             width: "100%",
//             padding: "8px 4px",
//             border: "1px solid black",
//             borderTop: "none",
//             fontSize: "14px",
//           }}
//         >
//           (Rupees {toWords(details.net_pay)} Only )
//         </div>

//         {/* Footer */}
//         <div
//           style={{
//             width: "100%",
//             padding: "8px 4px",
//             border: "1px solid black",
//             borderTop: "none",
//             fontSize: "12px",
//           }}
//         >
//           Note: This is computer generated statement and does not require
//           signature
//         </div>

//         {/* Close Button */}
//         <div style={{ textAlign: "center", marginTop: "20px" }}>
//           <button className="btn btn-danger" onClick={onClose}>
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default function Payroll() {
//   const [payrollData, setPayrollData] = useState([]);
//   // Inside your Payroll component
//   const [employeeDetailsForModal, setEmployeeDetailsForModal] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const [salaryMonth, setSalaryMonth] = useState("");
//   const history = useNavigate();
//   const [selectedMonth, setSelectedMonth] = useState("");

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [payslipDetails, setPayslipDetails] = useState(null);

//   const fetchPayrollData = async (page) => {
//     setLoading(true);
//     try {
//       const response = await axios.post(
//         // Using GET as it's more appropriate for fetching a list
//         // `http://localhost:1051/hrms/getEmployeeList?page=${page}&limit=${itemsPerPage}`
//         `https://api.policicue.com/hrms/getEmployeeList?page=${page}&limit=${itemsPerPage}`
//       );
//       setPayrollData(response.data.data || []);
//     } catch (error) {
//       console.error("Error fetching payroll data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPayrollData(currentPage);
//   }, [currentPage]);

//   const handleCalculateSalary = async () => {
//     if (!salaryMonth) {
//       alert("Please select a month to calculate the salary.");
//       return;
//     }
//     try {
//       const response = await axios.post(
//         // "http://localhost:1051/hrms/calculatePayrollForAll",
//         "https://api.policicue.com/hrms/calculatePayrollForAll",
//         { month: salaryMonth }
//       );

//       if (response.data && response.data.status === 1) {
//         const { successCount, failedCount, failedEmployees, message } =
//           response.data;
//         let alertMessage = `${message}\nSuccess: ${successCount}\nFailed: ${failedCount}`;

//         if (failedCount > 0) {
//           alertMessage +=
//             "\nCheck the console for details on failed employees.";
//           console.error("Failed Employee Calculations:", failedEmployees);
//         }
//         alert(alertMessage);
//       } else {
//         alert(
//           response.data.message || "Salary calculation initiated successfully!"
//         );
//       }
//     } catch (error) {
//       console.error("Error calculating salary:", error.response?.data || error);
//       alert(
//         error.response?.data?.message ||
//           "Salary calculation failed. Please try again."
//       );
//     }
//   };

//   const handleNextPage = () => {
//     setCurrentPage((prev) => prev + 1);
//   };
//   // Inside your Payroll component, modify this function
//   // Inside your Payroll component, modify this function
//   const handleViewPayslip = async (employeeId, month, employeeData) => {
//     // Added employeeData
//     if (!month) {
//       alert("Please select a month first");
//       return;
//     }
//     try {
//       const response = await axios.get(
//         // `http://localhost:1051/hrms/viewPayslip`,
//         `https://api.policicue.com/hrms/viewPayslip`,
//         {
//           params: { employee_id: employeeId, month: month },
//         }
//       );

//       if (response.data.status === 1) {
//         setPayslipDetails(response.data.data);
//         setEmployeeDetailsForModal(employeeData); // <-- Store employee data
//         setIsModalOpen(true);
//       } else {
//         alert(
//           response.data.message || "Could not find payslip for this month."
//         );
//       }
//     } catch (error) {
//       console.error("View Payslip error:", error);
//       alert("Failed to fetch payslip details.");
//     }
//   };
//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage((prev) => prev - 1);
//     }
//   };

//   const handleDownloadPayslip = async (employeeId, month) => {
//     if (!month) {
//       alert("Please select a month first");
//       return;
//     }
//     try {
//       const response = await axios.get(
//         // `http://localhost:1051/hrms/downloadPayslip`,
//         `https://api.policicue.com/hrms/downloadPayslip`,
//         {
//           params: { employee_id: employeeId, month: month },
//           responseType: "blob",
//         }
//       );

//       const blob = new Blob([response.data], { type: "application/pdf" });
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `Payslip_${employeeId}_${month}.pdf`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Download error:", error);
//       alert(
//         "Failed to download payslip. It may not exist for the selected month."
//       );
//     }
//   };

//   return (
//     <div className="Payroll">
//       {/* ✅ 2. RENDER THE MODAL COMPONENT CONDITIONALLY */}
//       {/* It will only appear when isModalOpen is true */}
//       {isModalOpen && (
//         <PayslipModal
//           details={payslipDetails}
//           employee={employeeDetailsForModal} // ✅ pass employee data
//           onClose={() => setIsModalOpen(false)}
//         />
//       )}

//       <div className="container-fluid my-2">
//         <div className="row">
//           <main className="mainBodyContainer">
//             {/* The rest of your JSX remains here... */}
//             <div className="row my-2">
//               <div className="col-10 py-2 px-3">
//                 <h4
//                   className="text-capitalize"
//                   style={{
//                     fontFamily: "ErasDemiITC",
//                     fontWeight: "bold",
//                     marginTop: "1rem",
//                     marginLeft: "12px",
//                   }}
//                 >
//                   Payroll
//                 </h4>
//               </div>
//               <div className="col-3 form-group" style={{ float: "right" }}>
//                 <label>Select Month to Calculate Salary:</label>
//                 <div className="d-flex align-items-center gap-2">
//                   <input
//                     type="month"
//                     className="form-control"
//                     value={salaryMonth}
//                     onChange={(e) => setSalaryMonth(e.target.value)}
//                   />
//                   <button
//                     className="btn btn-success"
//                     style={{ whiteSpace: "nowrap" }}
//                     onClick={handleCalculateSalary}
//                   >
//                     Calculate Salary
//                   </button>
//                 </div>
//               </div>
//               <div className="col-lg-3 col-md-4">
//                 <label className="form-label">
//                   {" "}
//                   Select Month to View Payslip:
//                 </label>
//                 <input
//                   type="month"
//                   className="form-control"
//                   value={selectedMonth}
//                   onChange={(e) => setSelectedMonth(e.target.value)}
//                 />
//               </div>
//             </div>
//             <div className="row my-2">
//               <div className="col-12 py-1 px-3">
//                 <div className="bg-white p-2 rounded-3 shadow-sm">
//                   {loading ? (
//                     <p>Loading...</p>
//                   ) : (
//                     <>
//                       <table className="table table-striped table-hover">
//                         <thead>
//                           <tr
//                             className="text-uppercase"
//                             style={{
//                               lineHeight: "15px",
//                               fontFamily: "Calibri",
//                               fontSize: "14px",
//                               color: "#7D90B2",
//                               backgroundColor: "#F4F7FC",
//                             }}
//                           >
//                             <th className="py-3">Employee</th>
//                             <th className="text-center py-3">Joining Date</th>
//                             <th className="text-center py-3">Department</th>
//                             <th className="text-center py-3">Salary</th>
//                             <th className="text-center py-3">Actions</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {payrollData.map((employee, index) => {
//                             const emp = employee.employeeData || {};
//                             return (
//                               <tr key={emp.id || index}>
//                                 <td>
//                                   <div>
//                                     {`${emp.first_name} ${emp.last_name}` ||
//                                       "--"}
//                                     <br />
//                                     <span
//                                       style={{
//                                         fontSize: "12px",
//                                         color: "#7D90B2",
//                                       }}
//                                     >
//                                       Emp ID: {emp.employee_id || "--"}
//                                     </span>
//                                   </div>
//                                 </td>
//                                 <td className="text-center">
//                                   {new Date(
//                                     emp.joining_date
//                                   ).toLocaleDateString()}
//                                 </td>
//                                 <td className="text-center">
//                                   {emp.department || "--"}
//                                 </td>
//                                 <td className="text-center">
//                                   ₹{emp.inhand_salary || "0"}
//                                 </td>

//                                 <td className="text-center">
//                                   <i
//                                     className="bi bi-box-arrow-down"
//                                     style={{
//                                       cursor: "pointer",
//                                       color: "#007bff",
//                                       paddingLeft: "20px",
//                                       fontSize: "1.2rem",
//                                     }}
//                                     title="Download Payslip"
//                                     onClick={() =>
//                                       handleDownloadPayslip(
//                                         emp.employee_id,
//                                         selectedMonth
//                                       )
//                                     }
//                                   ></i>
//                                   <i
//                                     className="bi bi-eye"
//                                     style={{
//                                       cursor: "pointer",
//                                       color: "#17a2b8",
//                                       paddingLeft: "20px",
//                                       fontSize: "1.2rem",
//                                     }}
//                                     title="View Payslip"
//                                     onClick={() =>
//                                       handleViewPayslip(
//                                         emp.employee_id,
//                                         selectedMonth,
//                                         emp
//                                       )
//                                     }
//                                   ></i>
//                                 </td>
//                               </tr>
//                             );
//                           })}
//                         </tbody>
//                       </table>

//                       <div className="d-flex justify-content-between align-items-center mt-3 px-2">
//                         <button
//                           className="btn btn-outline-primary btn-sm"
//                           onClick={handlePreviousPage}
//                           disabled={currentPage === 1}
//                         >
//                           Previous
//                         </button>
//                         <span>Page {currentPage}</span>
//                         <button
//                           className="btn btn-outline-primary btn-sm"
//                           onClick={handleNextPage}
//                           disabled={payrollData.length < itemsPerPage}
//                         >
//                           Next
//                         </button>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </main>
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useEffect, useState } from "react";
import axios from "axios";
// import Constant from "../../utils/constant"; // Assuming you might use this later
import { useNavigate } from "react-router-dom";

// ✅ 1. DEFINE THE MODAL AS A SEPARATE COMPONENT
// It receives `details` and `onClose` as props.
// Helper function to convert number to words (Simplified for Indian numbering)
const toWords = (num) => {
  const a = [
    "",
    "one ",
    "two ",
    "three ",
    "four ",
    "five ",
    "six ",
    "seven ",
    "eight ",
    "nine ",
    "ten ",
    "eleven ",
    "twelve ",
    "thirteen ",
    "fourteen ",
    "fifteen ",
    "sixteen ",
    "seventeen ",
    "eighteen ",
    "nineteen ",
  ];
  const b = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  const number = parseFloat(num).toFixed(2).split(".");
  const main = number[0];
  const decimal = number[1];

  if (main.length > 7) {
    return "Number too large";
  }

  const nToWords = (n) => {
    let str = "";
    if (n > 19) {
      str += b[Math.floor(n / 10)] + " " + a[n % 10];
    } else {
      str += a[n];
    }
    return str;
  };

  let str = "";
  str +=
    nToWords(Math.floor(main / 100000) % 100).length > 0
      ? nToWords(Math.floor(main / 100000) % 100) + "lakh "
      : "";
  str +=
    nToWords(Math.floor(main / 1000) % 100).length > 0
      ? nToWords(Math.floor(main / 1000) % 100) + "thousand "
      : "";
  str +=
    nToWords(Math.floor(main / 100) % 10).length > 0
      ? nToWords(Math.floor(main / 100) % 10) + "hundred "
      : "";
  if (main > 100 && main % 100 > 0) {
    str += "and ";
  }
  str += nToWords(main % 100);

  let decimalPart = "";
  if (decimal && parseInt(decimal) > 0) {
    decimalPart = ` and ${nToWords(parseInt(decimal))} paise`;
  }

  return str.trim() === ""
    ? "Zero"
    : str.trim().replace(/\s+/g, " ") + decimalPart;
};

// ✅ REPLACED MODAL COMPONENT
// ✅ REPLACED MODAL COMPONENT
const PayslipModal = ({ details, employee, onClose }) => {
  if (!details || !employee) {
    return null;
  }

  // ✅ 1. CALCULATE LEAVE DEDUCTION ON THE FRONTEND
  // Parse the required values from the API response
  const baseSalary = parseFloat(details.base_salary) || 0;
  const hra = parseFloat(details.hra) || 0;
  const conveyance = parseFloat(details.conveyance) || 0;
  const specialAllowance = parseFloat(details.special_allowance) || 0;
  const unpaidLeaveDays = parseFloat(details.unpaid_leave_days) || 0;

  // Calculate the full monthly gross salary (before any leave deduction)
  const fullGrossSalary = baseSalary + hra + conveyance + specialAllowance;

  // Calculate the deduction amount based on your formula
  const perDaySalary = fullGrossSalary / 30; // Assuming 30 days in a month for calculation
  const leaveDeductionAmount = perDaySalary * unpaidLeaveDays;

  // Format the month (e.g., "June, 2025")
  const payslipMonth = new Date(details.month + "-02").toLocaleString(
    "default",
    { month: "long", year: "numeric" }
  );
  const doj = new Date(employee.joining_date).toLocaleDateString("en-GB");

  const earnings = {
    BASIC: baseSalary,
    "H.R.A.": hra,
    "CONVEY.": conveyance,
    "SPL.ALL": specialAllowance,
    MEDICAL: 0,
    "ATT. ALL": 0,
    "PERF.BON": 0,
  };

  // ✅ 2. ADD THE CALCULATED LEAVE DEDUCTION TO THE DEDUCTIONS OBJECT
  const deductions = {
    "E.P.F. (Employee's Share)": parseFloat(details.pf) || 0,
    "E.S.I.C. (Employee's Share)": parseFloat(details.esi) || 0,
    ADVANCE: 0,
    TDS: 0,
    LOAN: 0,
    "P.TAX": 0,
    "LEAVE DEDUCTION": leaveDeductionAmount, // Use the calculated value here
  };

  // The total earnings should reflect the full salary before deductions
  const totalEarnings = Object.values(earnings).reduce(
    (acc, val) => acc + val,
    0
  );

  const totalDeductions = Object.values(deductions).reduce(
    (acc, val) => acc + val,
    0
  );

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1050,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "25px",
          fontFamily: "Arial, sans-serif",
          width: "800px",
          border: "1px solid black",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <h4 style={{ margin: "0", fontWeight: "bold" }}>
            M/S POLICICUE INSURANCE BROKERS PRIVATE LIMITED
          </h4>
          <p style={{ margin: "0" }}>
            A-42/6, Sector-62, Noida, Gautam Buddha Nagar, Uttar Pradesh-201301
          </p>
          <h5 style={{ margin: "10px 0 0 0", textDecoration: "underline" }}>
            Salary Slip for the month of {payslipMonth}
          </h5>
        </div>

        {/* Employee Details */}
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            border: "1px solid black",
            fontSize: "14px",
          }}
        >
          <tbody>
            <tr>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                Employee Code
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.employee_id}
              </td>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                P.F. Number
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.pf_number || "N/A"}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                Employee Name
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {details.employee_name.toUpperCase()}
              </td>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                PAN No.
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.pan_number || "N/A"}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                F/H Name
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.father_name || "N/A"}
              </td>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                Bank A/c No.
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.bank_account_number || "N/A"}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                Designation
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.joining_position || "N/A"}
              </td>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                ESI Number
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.esi_number || "N/A"}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                Department
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {employee.department}
              </td>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                D.O.J.
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {doj}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                Paid Days
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {details.work_days.toFixed(2)}
              </td>
              <td
                style={{
                  border: "1px solid black",
                  padding: "4px",
                  fontWeight: "bold",
                }}
              >
                Leave
              </td>
              <td style={{ border: "1px solid black", padding: "4px" }}>
                {details.leave_days.toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>

        {/* Earnings and Deductions */}
        <div
          style={{
            display: "flex",
            width: "100%",
            border: "1px solid black",
            borderTop: "none",
          }}
        >
          <div style={{ width: "60%", borderRight: "1px solid black" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid black",
                      padding: "4px",
                      borderTop: "none",
                      borderLeft: "none",
                    }}
                  >
                    Earnings
                  </th>
                  {/* <th
                    style={{
                      border: "1px solid black",
                      padding: "4px",
                      borderTop: "none",
                    }}
                  >
                    Rate
                  </th> */}
                  <th
                    style={{
                      border: "1px solid black",
                      padding: "4px",
                      borderTop: "none",
                      borderRight: "none",
                    }}
                  >
                    Earnings
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(earnings).map(([key, value]) => (
                  <tr key={key}>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "4px",
                        borderBottom: "none",
                        borderLeft: "none",
                      }}
                    >
                      {key}
                    </td>
                    {/* <td
                      style={{
                        border: "1px solid black",
                        padding: "4px",
                        borderBottom: "none",
                        textAlign: "right",
                      }}
                    >
                      {value.toFixed(2)}
                    </td> */}
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "4px",
                        borderBottom: "none",
                        borderRight: "none",
                        textAlign: "right",
                      }}
                    >
                      {value.toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ width: "40%" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid black",
                      padding: "4px",
                      borderTop: "none",
                      borderLeft: "none",
                    }}
                  >
                    Deductions
                  </th>
                  <th
                    style={{
                      border: "1px solid black",
                      padding: "4px",
                      borderTop: "none",
                      borderRight: "none",
                    }}
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(deductions).map(([key, value]) => (
                  <tr key={key}>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "4px",
                        borderBottom: "none",
                        borderLeft: "none",
                      }}
                    >
                      {key}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        padding: "4px",
                        borderBottom: "none",
                        borderRight: "none",
                        textAlign: "right",
                      }}
                    >
                      {value.toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Totals */}
        <div
          style={{
            display: "flex",
            width: "100%",
            border: "1px solid black",
            borderTop: "none",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          <div
            style={{
              width: "60%",
              display: "flex",
              borderRight: "1px solid black",
            }}
          >
            <div
              style={{
                width: "33.33%",
                padding: "4px",
                borderRight: "1px solid black",
              }}
            >
              Total
            </div>
            {/* <div
              style={{
                width: "33.33%",
                padding: "4px",
                textAlign: "right",
                borderRight: "1px solid black",
              }}
            >
              {totalEarnings.toFixed(2)}
            </div> */}
            <div
              style={{ width: "33.33%", padding: "4px", textAlign: "right" }}
            >
              {totalEarnings.toFixed(2)}
            </div>
          </div>
          <div style={{ width: "40%", display: "flex" }}>
            <div
              style={{
                width: "50%",
                padding: "4px",
                borderRight: "1px solid black",
              }}
            >
              Total
            </div>
            <div style={{ width: "50%", padding: "4px", textAlign: "right" }}>
              {totalDeductions.toFixed(2)}
            </div>
          </div>
        </div>

        {/* Net Payable */}
        <div
          style={{
            display: "flex",
            width: "100%",
            border: "1px solid black",
            borderTop: "none",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          <div style={{ width: "60%", padding: "4px" }}>
            Net Payable for the Month {payslipMonth}
          </div>
          <div style={{ width: "40%", padding: "4px", textAlign: "right" }}>
            {details.net_pay}
          </div>
        </div>

        {/* In Words */}
        <div
          style={{
            width: "100%",
            padding: "8px 4px",
            border: "1px solid black",
            borderTop: "none",
            fontSize: "14px",
          }}
        >
          (Rupees {toWords(details.net_pay)} Only )
        </div>

        {/* Footer */}
        <div
          style={{
            width: "100%",
            padding: "8px 4px",
            border: "1px solid black",
            borderTop: "none",
            fontSize: "12px",
          }}
        >
          Note: This is computer generated statement and does not require
          signature
        </div>

        {/* Close Button */}
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <button className="btn btn-danger" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

const Payroll = () => {
  const [activeScreen, setActiveScreen] = useState("dashboard");
  const [selectedMonth, setSelectedMonth] = useState("2025-01");
  const [employees] = useState([
    {
      id: "EMP001",
      name: "Rajesh Kumar",
      designation: "Senior Developer",
      basic: 45000,
      hra: 18000,
      pf: 5400,
      esic: 675,
      travel: 3000,
      medical: 2000,
      overtimeRate: 300,
      present: 22,
      paidLeave: 2,
      unpaidLeave: 0,
      overtime: 5,
      status: "Processed",
    },
    {
      id: "EMP002",
      name: "Priya Sharma",
      designation: "UI/UX Designer",
      basic: 38000,
      hra: 15200,
      pf: 4560,
      esic: 570,
      travel: 2500,
      medical: 1500,
      overtimeRate: 250,
      present: 20,
      paidLeave: 2,
      unpaidLeave: 2,
      overtime: 3,
      status: "Pending",
    },
    {
      id: "EMP003",
      name: "Amit Patel",
      designation: "Marketing Manager",
      basic: 50000,
      hra: 20000,
      pf: 6000,
      esic: 750,
      travel: 4000,
      medical: 2500,
      overtimeRate: 350,
      present: 24,
      paidLeave: 0,
      unpaidLeave: 0,
      overtime: 8,
      status: "Processed",
    },
  ]);

  const calculatePayroll = (emp) => {
    const workingDays = 24;
    const actualDays = emp.present + emp.paidLeave;
    const dailyBasic = emp.basic / workingDays;
    const adjustedBasic = dailyBasic * actualDays;

    const overtimePay = emp.overtime * emp.overtimeRate;
    const gross =
      adjustedBasic + emp.hra + emp.travel + emp.medical + overtimePay;
    const deductions = emp.pf + emp.esic;
    const net = gross - deductions;

    return { adjustedBasic, overtimePay, gross, deductions, net };
  };

  const totalStats = employees.reduce(
    (acc, emp) => {
      const calc = calculatePayroll(emp);
      return {
        processed: acc.processed + (emp.status === "Processed" ? 1 : 0),
        pending: acc.pending + (emp.status === "Pending" ? 1 : 0),
        totalPayout: acc.totalPayout + calc.net,
        totalOvertime: acc.totalOvertime + emp.overtime * emp.overtimeRate,
      };
    },
    { processed: 0, pending: 0, totalPayout: 0, totalOvertime: 0 }
  );

  const DashboardScreen = () => (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-800">Payroll Dashboard</h2>
        <select
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
          className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option value="2025-01">January 2025</option>
          <option value="2024-12">December 2024</option>
          <option value="2024-11">November 2024</option>
        </select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-white border-l-4 border-slate-600 rounded-lg p-6 shadow-sm">
          <div className="flex items-center justify-between mb-2">
            <Users className="w-8 h-8 text-slate-600" />
            <span className="text-3xl font-bold text-gray-800">
              {employees.length}
            </span>
          </div>
          <p className="text-gray-600 text-sm">Total Employees</p>
        </div>

        <div className="bg-white border-l-4 border-emerald-600 rounded-lg p-6 shadow-sm">
          <div className="flex items-center justify-between mb-2">
            <FileText className="w-8 h-8 text-emerald-600" />
            <span className="text-3xl font-bold text-gray-800">
              {totalStats.processed}
            </span>
          </div>
          <p className="text-gray-600 text-sm">Payroll Processed</p>
        </div>

        <div className="bg-white border-l-4 border-amber-600 rounded-lg p-6 shadow-sm">
          <div className="flex items-center justify-between mb-2">
            <AlertCircle className="w-8 h-8 text-amber-600" />
            <span className="text-3xl font-bold text-gray-800">
              {totalStats.pending}
            </span>
          </div>
          <p className="text-gray-600 text-sm">Pending Employees</p>
        </div>

        <div className="bg-white border-l-4 border-indigo-600 rounded-lg p-6 shadow-sm">
          <div className="flex items-center justify-between mb-2">
            <DollarSign className="w-8 h-8 text-indigo-600" />
            <span className="text-3xl font-bold text-gray-800">
              ₹{(totalStats.totalPayout / 1000).toFixed(0)}K
            </span>
          </div>
          <p className="text-gray-600 text-sm">Total Payout</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
          <h3 className="text-lg font-semibold mb-4 flex items-center gap-2 text-gray-800">
            <Clock className="w-5 h-5 text-slate-600" />
            Overtime Statistics
          </h3>
          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <span className="text-gray-600">Total Overtime Hours</span>
              <span className="font-semibold text-gray-800">
                {employees.reduce((acc, e) => acc + e.overtime, 0)} hrs
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-600">Overtime Payout</span>
              <span className="font-semibold text-emerald-700">
                ₹{totalStats.totalOvertime.toLocaleString()}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-600">Avg Overtime/Employee</span>
              <span className="font-semibold text-gray-800">
                {(
                  employees.reduce((acc, e) => acc + e.overtime, 0) /
                  employees.length
                ).toFixed(1)}{" "}
                hrs
              </span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
          <h3 className="text-lg font-semibold mb-4 flex items-center gap-2 text-gray-800">
            <TrendingUp className="w-5 h-5 text-slate-600" />
            Quick Actions
          </h3>
          <div className="space-y-3">
            <button
              onClick={() => setActiveScreen("process")}
              className="w-full bg-slate-700 hover:bg-slate-800 text-white py-3 rounded-lg font-medium transition-colors"
            >
              Process This Month Payroll
            </button>
            <button
              onClick={() => setActiveScreen("salarySlips")}
              className="w-full bg-emerald-700 hover:bg-emerald-800 text-white py-3 rounded-lg font-medium transition-colors"
            >
              Generate Salary Slips
            </button>
            <button
              onClick={() => setActiveScreen("history")}
              className="w-full bg-indigo-700 hover:bg-indigo-800 text-white py-3 rounded-lg font-medium transition-colors"
            >
              View Payroll History
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  const SalaryStructureScreen = () => (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-800">
          Salary Structure Management
        </h2>
        <button className="flex items-center gap-2 bg-slate-700 hover:bg-slate-800 text-white px-4 py-2 rounded-lg font-medium transition-colors">
          <Plus className="w-4 h-4" />
          Add Employee
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">
                  Employee
                </th>
                <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase">
                  Basic
                </th>
                <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase">
                  HRA
                </th>
                <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase">
                  Travel
                </th>
                <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase">
                  Medical
                </th>
                <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase">
                  PF
                </th>
                <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase">
                  ESIC
                </th>
                <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase">
                  OT Rate
                </th>
                <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {employees.map((emp) => (
                <tr key={emp.id} className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4">
                    <div>
                      <div className="font-semibold text-gray-800">
                        {emp.name}
                      </div>
                      <div className="text-sm text-gray-500">
                        {emp.id} • {emp.designation}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right font-medium">
                    ₹{emp.basic.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 text-right">
                    ₹{emp.hra.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 text-right">
                    ₹{emp.travel.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 text-right">
                    ₹{emp.medical.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 text-right text-red-600">
                    ₹{emp.pf.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 text-right text-red-600">
                    ₹{emp.esic.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 text-right">
                    ₹{emp.overtimeRate}/hr
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center justify-center gap-2">
                      <button className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors">
                        <Edit className="w-4 h-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  const ProcessPayrollScreen = () => (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800">
        Process Monthly Payroll
      </h2>

      <div className="bg-white rounded-xl p-6 shadow-md">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Select Month
            </label>
            <input
              type="month"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Working Days
            </label>
            <input
              type="number"
              defaultValue="24"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div className="flex items-end">
            <button className="w-full bg-slate-700 hover:bg-slate-800 text-white px-4 py-2 rounded-lg font-medium transition-colors">
              Fetch Attendance Data
            </button>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">
                  Employee
                </th>
                <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase">
                  Present
                </th>
                <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase">
                  Paid Leave
                </th>
                <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase">
                  Unpaid Leave
                </th>
                <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase">
                  Overtime
                </th>
                <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase">
                  Gross Pay
                </th>
                <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase">
                  Deductions
                </th>
                <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase">
                  Net Pay
                </th>
                <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {employees.map((emp) => {
                const calc = calculatePayroll(emp);
                return (
                  <tr
                    key={emp.id}
                    className="hover:bg-gray-50 transition-colors"
                  >
                    <td className="px-6 py-4">
                      <div>
                        <div className="font-semibold text-gray-800">
                          {emp.name}
                        </div>
                        <div className="text-sm text-gray-500">{emp.id}</div>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-center font-medium">
                      {emp.present}
                    </td>
                    <td className="px-6 py-4 text-center text-green-600">
                      {emp.paidLeave}
                    </td>
                    <td className="px-6 py-4 text-center text-red-600">
                      {emp.unpaidLeave}
                    </td>
                    <td className="px-6 py-4 text-center text-blue-600">
                      {emp.overtime}h
                    </td>
                    <td className="px-6 py-4 text-right font-medium">
                      ₹{calc.gross.toLocaleString()}
                    </td>
                    <td className="px-6 py-4 text-right text-red-600">
                      ₹{calc.deductions.toLocaleString()}
                    </td>
                    <td className="px-6 py-4 text-right font-bold text-green-600">
                      ₹{calc.net.toLocaleString()}
                    </td>
                    <td className="px-6 py-4 text-center">
                      <span
                        className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                          emp.status === "Processed"
                            ? "bg-green-100 text-green-800"
                            : "bg-orange-100 text-orange-800"
                        }`}
                      >
                        {emp.status}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <div className="flex justify-end gap-4">
        <button className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors">
          Preview Calculation
        </button>
        <button className="px-6 py-3 bg-green-500 hover:bg-green-600 text-white rounded-lg font-medium transition-colors">
          Confirm & Process Payroll
        </button>
      </div>
    </div>
  );

  const SalarySlipsScreen = () => (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-800">Salary Slips</h2>
        <button className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg font-medium transition-colors">
          <Download className="w-4 h-4" />
          Download All
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {employees.map((emp) => {
          const calc = calculatePayroll(emp);
          return (
            <div
              key={emp.id}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="font-semibold text-lg text-gray-800">
                    {emp.name}
                  </h3>
                  <p className="text-sm text-gray-500">{emp.id}</p>
                  <p className="text-xs text-gray-400 mt-1">
                    {emp.designation}
                  </p>
                </div>
                <span
                  className={`px-3 py-1 rounded-full text-xs font-medium ${
                    emp.status === "Processed"
                      ? "bg-green-100 text-green-800"
                      : "bg-orange-100 text-orange-800"
                  }`}
                >
                  {emp.status}
                </span>
              </div>

              <div className="border-t border-b border-gray-200 py-4 space-y-2 mb-4">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Gross Salary</span>
                  <span className="font-medium">
                    ₹{calc.gross.toLocaleString()}
                  </span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Deductions</span>
                  <span className="font-medium text-red-600">
                    -₹{calc.deductions.toLocaleString()}
                  </span>
                </div>
                <div className="flex justify-between text-base font-bold">
                  <span>Net Salary</span>
                  <span className="text-green-600">
                    ₹{calc.net.toLocaleString()}
                  </span>
                </div>
              </div>

              <div className="flex gap-2">
                <button className="flex-1 flex items-center justify-center gap-2 bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-lg font-medium transition-colors">
                  <Eye className="w-4 h-4" />
                  View
                </button>
                <button className="flex-1 flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white py-2 rounded-lg font-medium transition-colors">
                  <Download className="w-4 h-4" />
                  PDF
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  const HistoryScreen = () => (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800">Payroll History</h2>

      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">
                  Month
                </th>
                <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase">
                  Employees
                </th>
                <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase">
                  Total Payout
                </th>
                <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase">
                  Status
                </th>
                <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {[
                "January 2025",
                "December 2024",
                "November 2024",
                "October 2024",
              ].map((month, idx) => (
                <tr key={idx} className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <Calendar className="w-5 h-5 text-blue-500" />
                      <span className="font-semibold text-gray-800">
                        {month}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-center font-medium">
                    {employees.length}
                  </td>
                  <td className="px-6 py-4 text-right font-bold text-green-600">
                    ₹{totalStats.totalPayout.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 text-center">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      Completed
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center justify-center gap-2">
                      <button className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors">
                        <Eye className="w-4 h-4" />
                      </button>
                      <button className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors">
                        <Download className="w-4 h-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold text-gray-900">
              HR Payroll Management
            </h1>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <Calendar className="w-4 h-4" />
              <span>January 2025</span>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-6">
        <div className="flex gap-4 mb-6 overflow-x-auto pb-2">
          <button
            onClick={() => setActiveScreen("dashboard")}
            className={`px-4 py-2 rounded-lg font-medium whitespace-nowrap transition-colors ${
              activeScreen === "dashboard"
                ? "bg-blue-500 text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
          >
            Dashboard
          </button>
          <button
            onClick={() => setActiveScreen("salary")}
            className={`px-4 py-2 rounded-lg font-medium whitespace-nowrap transition-colors ${
              activeScreen === "salary"
                ? "bg-blue-500 text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
          >
            Salary Structure
          </button>
          <button
            onClick={() => setActiveScreen("process")}
            className={`px-4 py-2 rounded-lg font-medium whitespace-nowrap transition-colors ${
              activeScreen === "process"
                ? "bg-blue-500 text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
          >
            Process Payroll
          </button>
          <button
            onClick={() => setActiveScreen("salarySlips")}
            className={`px-4 py-2 rounded-lg font-medium whitespace-nowrap transition-colors ${
              activeScreen === "salarySlips"
                ? "bg-blue-500 text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
          >
            Salary Slips
          </button>
          <button
            onClick={() => setActiveScreen("history")}
            className={`px-4 py-2 rounded-lg font-medium whitespace-nowrap transition-colors ${
              activeScreen === "history"
                ? "bg-blue-500 text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
          >
            History
          </button>
        </div>

        {activeScreen === "dashboard" && <DashboardScreen />}
        {activeScreen === "salary" && <SalaryStructureScreen />}
        {activeScreen === "process" && <ProcessPayrollScreen />}
        {activeScreen === "salarySlips" && <SalarySlipsScreen />}
        {activeScreen === "history" && <HistoryScreen />}
      </div>
    </div>
  );
};

export default Payroll;

// export default function Payroll() {
//   const [payrollData, setPayrollData] = useState([]);
//   // Inside your Payroll component
//   const [employeeDetailsForModal, setEmployeeDetailsForModal] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const [salaryMonth, setSalaryMonth] = useState("");
//   const history = useNavigate();
//   const [selectedMonth, setSelectedMonth] = useState("");

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [payslipDetails, setPayslipDetails] = useState(null);

//   const fetchPayrollData = async (page) => {
//     setLoading(true);
//     try {
//       const response = await axios.post(
//         // Using GET as it's more appropriate for fetching a list
//         // `http://localhost:1051/hrms/getEmployeeList?page=${page}&limit=${itemsPerPage}`
//         `https://api.policicue.com/hrms/getEmployeeList?page=${page}&limit=${itemsPerPage}`
//       );
//       setPayrollData(response.data.data || []);
//     } catch (error) {
//       console.error("Error fetching payroll data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPayrollData(currentPage);
//   }, [currentPage]);

//   const handleCalculateSalary = async () => {
//     if (!salaryMonth) {
//       alert("Please select a month to calculate the salary.");
//       return;
//     }
//     try {
//       const response = await axios.post(
//         // "http://localhost:1051/hrms/calculatePayrollForAll",
//         "https://api.policicue.com/hrms/calculatePayrollForAll",
//         { month: salaryMonth }
//       );

//       if (response.data && response.data.status === 1) {
//         const { successCount, failedCount, failedEmployees, message } =
//           response.data;
//         let alertMessage = `${message}\nSuccess: ${successCount}\nFailed: ${failedCount}`;

//         if (failedCount > 0) {
//           alertMessage +=
//             "\nCheck the console for details on failed employees.";
//           console.error("Failed Employee Calculations:", failedEmployees);
//         }
//         alert(alertMessage);
//       } else {
//         alert(
//           response.data.message || "Salary calculation initiated successfully!"
//         );
//       }
//     } catch (error) {
//       console.error("Error calculating salary:", error.response?.data || error);
//       alert(
//         error.response?.data?.message ||
//           "Salary calculation failed. Please try again."
//       );
//     }
//   };

//   const handleNextPage = () => {
//     setCurrentPage((prev) => prev + 1);
//   };
//   // Inside your Payroll component, modify this function
//   // Inside your Payroll component, modify this function
//   const handleViewPayslip = async (employeeId, month, employeeData) => {
//     // Added employeeData
//     if (!month) {
//       alert("Please select a month first");
//       return;
//     }
//     try {
//       const response = await axios.get(
//         // `http://localhost:1051/hrms/viewPayslip`,
//         `https://api.policicue.com/hrms/viewPayslip`,
//         {
//           params: { employee_id: employeeId, month: month },
//         }
//       );

//       if (response.data.status === 1) {
//         setPayslipDetails(response.data.data);
//         setEmployeeDetailsForModal(employeeData); // <-- Store employee data
//         setIsModalOpen(true);
//       } else {
//         alert(
//           response.data.message || "Could not find payslip for this month."
//         );
//       }
//     } catch (error) {
//       console.error("View Payslip error:", error);
//       alert("Failed to fetch payslip details.");
//     }
//   };
//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage((prev) => prev - 1);
//     }
//   };

//   const handleDownloadPayslip = async (employeeId, month) => {
//     if (!month) {
//       alert("Please select a month first");
//       return;
//     }
//     try {
//       const response = await axios.get(
//         // `http://localhost:1051/hrms/downloadPayslip`,
//         `https://api.policicue.com/hrms/downloadPayslip`,
//         {
//           params: { employee_id: employeeId, month: month },
//           responseType: "blob",
//         }
//       );

//       const blob = new Blob([response.data], { type: "application/pdf" });
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `Payslip_${employeeId}_${month}.pdf`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Download error:", error);
//       alert(
//         "Failed to download payslip. It may not exist for the selected month."
//       );
//     }
//   };

//   return (
//     <div className="Payroll">
//       {/* ✅ 2. RENDER THE MODAL COMPONENT CONDITIONALLY */}
//       {/* It will only appear when isModalOpen is true */}
//       {isModalOpen && (
//         <PayslipModal
//           details={payslipDetails}
//           employee={employeeDetailsForModal} // ✅ pass employee data
//           onClose={() => setIsModalOpen(false)}
//         />
//       )}

//       <div className="container-fluid my-2">
//         <div className="row">
//           <main className="mainBodyContainer">
//             {/* The rest of your JSX remains here... */}
//             <div className="row my-2">
//               {/* <div className="col-10 py-2 px-3"> */}
//               <div className="col">
//                 <h4
//                   className="text-capitalize"
//                   style={{
//                     fontFamily: "ErasDemiITC",
//                     fontWeight: "bold",
//                     marginTop: "1rem",
//                     marginLeft: "12px",
//                   }}
//                 >
//                   Payroll
//                 </h4>
//               </div>
//               {/* <div className="col-3 form-group"> */}
//               <div className="col-auto">
//                 <label>Select Month to Calculate Salary:</label>
//                 <div className="d-flex align-items-center gap-2">
//                   <input
//                     type="month"
//                     className="form-control"
//                     value={salaryMonth}
//                     onChange={(e) => setSalaryMonth(e.target.value)}
//                   />
//                   <button
//                     className="btn btn-success"
//                     style={{ whiteSpace: "nowrap" }}
//                     onClick={handleCalculateSalary}
//                   >
//                     Calculate Salary
//                   </button>
//                 </div>
//               </div>
//               {/* <div className="col-lg-3 col-md-4" style={{ float: "right" }}> */}
//               <div className="col-auto">
//                 <label className="form-label">
//                   {" "}
//                   Select Month to View Payslip:
//                 </label>
//                 <input
//                   type="month"
//                   className="form-control"
//                   value={selectedMonth}
//                   onChange={(e) => setSelectedMonth(e.target.value)}
//                 />
//               </div>
//             </div>
//             <div className="row my-2">
//               <div className="col-12 py-1 px-3">
//                 <div className="bg-white p-2 rounded-3 shadow-sm">
//                   {loading ? (
//                     <p>Loading...</p>
//                   ) : (
//                     <>
//                       <table className="table table-striped table-hover">
//                         <thead>
//                           <tr
//                             className="text-uppercase"
//                             style={{
//                               lineHeight: "15px",
//                               fontFamily: "Calibri",
//                               fontSize: "14px",
//                               color: "#7D90B2",
//                               backgroundColor: "#F4F7FC",
//                             }}
//                           >
//                             <th className="py-3">Employee</th>
//                             <th className="text-center py-3">Joining Date</th>
//                             <th className="text-center py-3">Department</th>
//                             <th className="text-center py-3">Salary</th>
//                             <th className="text-center py-3">Actions</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {payrollData.map((employee, index) => {
//                             const emp = employee.employeeData || {};
//                             return (
//                               <tr key={emp.id || index}>
//                                 <td>
//                                   <div>
//                                     {`${emp.first_name} ${emp.last_name}` ||
//                                       "--"}
//                                     <br />
//                                     <span
//                                       style={{
//                                         fontSize: "12px",
//                                         color: "#7D90B2",
//                                       }}
//                                     >
//                                       Emp ID: {emp.employee_id || "--"}
//                                     </span>
//                                   </div>
//                                 </td>
//                                 <td className="text-center">
//                                   {new Date(
//                                     emp.joining_date
//                                   ).toLocaleDateString()}
//                                 </td>
//                                 <td className="text-center">
//                                   {emp.department || "--"}
//                                 </td>
//                                 <td className="text-center">
//                                   ₹{emp.inhand_salary || "0"}
//                                 </td>

//                                 <td className="text-center">
//                                   <i
//                                     className="bi bi-box-arrow-down"
//                                     style={{
//                                       cursor: "pointer",
//                                       color: "#007bff",
//                                       paddingLeft: "20px",
//                                       fontSize: "1.2rem",
//                                     }}
//                                     title="Download Payslip"
//                                     onClick={() =>
//                                       handleDownloadPayslip(
//                                         emp.employee_id,
//                                         selectedMonth
//                                       )
//                                     }
//                                   ></i>
//                                   <i
//                                     className="bi bi-eye"
//                                     style={{
//                                       cursor: "pointer",
//                                       color: "#17a2b8",
//                                       paddingLeft: "20px",
//                                       fontSize: "1.2rem",
//                                     }}
//                                     title="View Payslip"
//                                     onClick={() =>
//                                       handleViewPayslip(
//                                         emp.employee_id,
//                                         selectedMonth,
//                                         emp
//                                       )
//                                     }
//                                   ></i>
//                                 </td>
//                               </tr>
//                             );
//                           })}
//                         </tbody>
//                       </table>

//                       <div className="d-flex justify-content-between align-items-center mt-3 px-2">
//                         <button
//                           className="btn btn-outline-primary btn-sm"
//                           onClick={handlePreviousPage}
//                           disabled={currentPage === 1}
//                         >
//                           Previous
//                         </button>
//                         <span>Page {currentPage}</span>
//                         <button
//                           className="btn btn-outline-primary btn-sm"
//                           onClick={handleNextPage}
//                           disabled={payrollData.length < itemsPerPage}
//                         >
//                           Next
//                         </button>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </main>
//         </div>
//       </div>
//     </div>
//   );
// }
